import { requiredRule, ValidateOptions } from '@.hooks';
import { ParentCompanyCreateType } from '@/Types/ParentCompany';

export const createValidateOptions = (): ValidateOptions<ParentCompanyCreateType> => ({
    name: {
        type: 'string',
        required: requiredRule,
    },
    image_id: {
        type: 'number',
        required: false,
    },
});
